import { FC } from 'react';
import { EngagementsListPage } from './engagements-list.page';
import { getLocalStorageDistrictId } from '../../../_core/utils';
import { useSessionStorage } from '../../../../hooks';
import { useGetAllFieldsQuery } from '../../../../../src/store/api/customRequirements.api';
import { useGetAllProvidersByDistrictIdQuery } from '../../../../../src/store/api/providers.api';
import {
	useGetAllFamiliesByDistrictIdQuery,
	useGetChildrenByDistrictIdQuery,
} from '../../../../../src/store/api/families.api';
import { useGetAllEngagementStatusesQuery, useGetEngagementStatusesQuery } from '../../../../store/api/engagements.api';
import { EngagementColumnName } from '../../hooks/table-columns/engagements-table-columns.hook';
import { AllowedEngagementActions } from '../../components/engagements-table/engagements-table-actions.component';

export const EngagementsListDistrictLevelPage: FC = () => {
	const [sessionStorageDistrictId] = useSessionStorage('districtId');
	const districtId = sessionStorageDistrictId ?? getLocalStorageDistrictId();

	const { data: fieldsListFromDistrict } = useGetAllFieldsQuery({ districtId }, { skip: !districtId });
	const { data: providersList } = useGetAllProvidersByDistrictIdQuery({ districtId }, { skip: !districtId });
	const { data: familiesList } = useGetAllFamiliesByDistrictIdQuery({ district: districtId }, { skip: !districtId });
	const { data: childrenList } = useGetChildrenByDistrictIdQuery({ districtId }, { skip: !districtId });
	const { data: statusesList } = useGetAllEngagementStatusesQuery();
	const engagementColumnsList: EngagementColumnName[] = [
		'title',
		'customId',
		'provider',
		'language',
		'duration',
		'status',
		'surveyStatus',
		'actions',
	];

	const engagementLinguistLinkColumnsList: EngagementColumnName[] = [
		'title',
		'customId',
		'provider',
		'language',
		'duration',
		'status',
		'surveyStatus',
		'isLinkedToFamily',
		'actions',
	];
	const allowedEngagementActions: AllowedEngagementActions[] = ['view', 'archive', 'delete', 'edit', 'email', 'sms'];

	return (
		<EngagementsListPage
			permission={{ create: true }}
			isAdminRoute={false}
			engagementColumnsList={engagementColumnsList}
			allowedEngagementActions={allowedEngagementActions}
			currentDistrictId={districtId}
			fieldsListFromDistrict={fieldsListFromDistrict}
			providersList={providersList}
			familiesList={familiesList}
			childrenList={childrenList}
			statusesList={statusesList}
			engagementLinguistLinkColumnsList={engagementLinguistLinkColumnsList}
		/>
	);
};
